import { render, staticRenderFns } from "./ProductsInPrestage.vue?vue&type=template&id=40a674a4&scoped=true&"
import script from "./ProductsInPrestage.vue?vue&type=script&lang=js&"
export * from "./ProductsInPrestage.vue?vue&type=script&lang=js&"
import style0 from "./ProductsInPrestage.vue?vue&type=style&index=0&id=40a674a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40a674a4",
  null
  
)

export default component.exports